import styled, { css } from "styled-components/macro";

import { ReactComponent as CrossIconBase } from "../../assets/icons/icon_cross.svg";

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 28px;
  overflow: hidden;

  @media (max-width: 999px) {
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const CardList = styled.ul`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  width: max-content;
`

export const CardItem = styled.li<{
  $hasNextCard: boolean;
  $isActiveCard: boolean;
  $zIndex: number;
}>`
  position: relative;
  z-index: ${({ $zIndex }) => $zIndex};
  width: 360px;
  height: 360px;
  flex: 0 0 360px;
  border: 1px ${({ $isActiveCard }) => ($isActiveCard ? "solid" : "dashed")}
    ${({ $isActiveCard }) => ($isActiveCard ? "#FFFFFF" : "rgba(169, 169, 169, 1)")};
  border-radius: 50%;
  background: #07060A;
  box-shadow: inset 23px 16px 63px 300px rgba(208, 216, 255, 0.05);
  overflow: hidden;

  & + & {
    margin-left: -40px;
  }

  ${({ $hasNextCard }) => $hasNextCard
    ? css`
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 340px;
        z-index: 1;
        width: 360px;
        height: 360px;
        border-radius: 50%;
        background: radial-gradient(
          circle,
          transparent 66%,
          rgba(208, 216, 255, 0.12) 70%,
          transparent 76%
        );
        filter: blur(10px);
        opacity: 0.9;
        pointer-events: none;
      }
    `
    : ""};

  @media (max-width: 1320px) {
    width: 280px;
    height: 280px;
    flex: 0 0 280px;
  }
`

export const CardText = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 270px;
  transform: translate(-50%, -50%);
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  text-transform: uppercase;
  z-index: 3;

  @media (max-width: 1320px) {
    width: 200px;
  }
`

export const DefaultText = styled.span`
  display: block;
  transition: opacity 0.25s ease;
`

export const HoverText = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #141414;
  opacity: 0;
  text-transform: uppercase;
  transition: opacity 0.25s ease;
`

export const ArrowIcon = styled.span`
  position: absolute;
  top: 50%;
  right: 25px;
  width: 10px;
  height: 10px;
  border-top: 1px solid #FFFFFF;
  border-right: 1px solid #FFFFFF;
  transform: translateY(-50%) rotate(45deg);
  transition: border-color 0.25s ease;
  z-index: 3;
`

export const CardFill = styled.span`
  position: absolute;
  left: 50%;
  bottom: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #FFFFFF;
  pointer-events: none;
  transform: translateX(-50%) scale(1);
  transition: transform 0.45s ease;
  z-index: 2;

  @media (max-width: 1320px) {
    width: 31px;
    height: 31px;
  }
`

export const CardButton = styled.a`
  position: absolute;
  left: 50%;
  bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #FFFFFF;
  cursor: pointer;
  transform: translateX(-50%);
  z-index: 4;

  &:hover ~ ${CardFill} {
    transform: translateX(-50%) scale(20);
  }

  &:hover ~ ${CardText} ${DefaultText} {
    opacity: 0;
  }

  &:hover ~ ${CardText} ${HoverText} {
    opacity: 1;
  }

  &:hover ~ ${ArrowIcon} {
    border-color: #141414;
  }

  @media (max-width: 1320px) {
    width: 31px;
    height: 31px;
  }
`

export const CrossIcon = styled(CrossIconBase)`
  width: 16px;
  height: 16px;
  color: #141414;

  path {
    fill: currentColor;
  }

  @media (max-width: 1320px) {
    width: 12px;
    height: 12px;
  }
`
